function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.5 2.456a3 3 0 00-3 3v9a3 3 0 003 3h6v3h-3a1.5 1.5 0 00-1.5 1.5v1.5h12v-1.5a1.5 1.5 0 00-1.5-1.5h-3v-3h6a3 3 0 003-3v-9a3 3 0 00-3-3h-15zm15 3h-15v9h15v-9z",
  fill: "#81858D"
});

var SvgMonitor = function SvgMonitor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjUgMi40NTYwNUMyLjg0MzE1IDIuNDU2MDUgMS41IDMuNzk5MiAxLjUgNS40NTYwNVYxNC40NTYxQzEuNSAxNi4xMTI5IDIuODQzMTUgMTcuNDU2MSA0LjUgMTcuNDU2MUgxMC41VjIwLjQ1NjFINy41QzYuNjcxNTcgMjAuNDU2MSA2IDIxLjEyNzYgNiAyMS45NTYxVjIzLjQ1NjFIMThWMjEuOTU2MUMxOCAyMS4xMjc2IDE3LjMyODQgMjAuNDU2MSAxNi41IDIwLjQ1NjFIMTMuNVYxNy40NTYxSDE5LjVDMjEuMTU2OSAxNy40NTYxIDIyLjUgMTYuMTEyOSAyMi41IDE0LjQ1NjFWNS40NTYwNUMyMi41IDMuNzk5MiAyMS4xNTY5IDIuNDU2MDUgMTkuNSAyLjQ1NjA1SDQuNVpNMTkuNSA1LjQ1NjA1SDQuNUw0LjUgMTQuNDU2MUgxOS41VjUuNDU2MDVaIiBmaWxsPSIjODE4NThEIi8+Cjwvc3ZnPg==";
export { SvgMonitor as ReactComponent };